import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import api, { apiError } from "@/api";
import { useAuth } from "@/context/AuthContext";
import { DataTable } from "@/components/DataTable";
import { PageHeader } from "@/components/PageHeader";
import { StatusBadge } from "@/components/StatusBadge";
import { Button } from "@/components/ui/button";
import { fmtIDR, fmtDate, PAYMENT_STATUS } from "@/lib/format";
import { CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function Payments() {
  const { event, eventId } = useOutletContext();
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);
  const canValidate = ["finance", "admin"].some((r) => user.roles.includes(r));

  const load = async () => setOrders((await api.get(`/orders?event_id=${eventId}`)).data);
  useEffect(() => { load(); }, [eventId]); // eslint-disable-line react-hooks/exhaustive-deps

  const validate = async (oid) => {
    try { await api.post(`/orders/${oid}/validate-payment`); toast.success("Pembayaran divalidasi — order masuk shopping list"); load(); }
    catch (e) { toast.error(apiError(e)); }
  };

  const columns = [
    { key: "id", label: "Order ID", mono: true, render: (r) => r.id.slice(0, 8) },
    { key: "created_at", label: "Tanggal", render: (r) => fmtDate(r.created_at), raw: (r) => fmtDate(r.created_at) },
    { key: "customer_name", label: "Customer", render: (r) => <span className="font-semibold text-slate-900">{r.customer_name}</span> },
    { key: "total", label: "Nominal", mono: true, render: (r) => <span className="font-semibold">{fmtIDR(r.total)}</span>, raw: (r) => r.total },
    { key: "payment_status", label: "Status", render: (r) => <StatusBadge map={PAYMENT_STATUS} value={r.payment_status} />, raw: (r) => r.payment_status },
    { key: "actions", label: "Aksi", sortable: false, noExport: true, render: (r) => (
      r.payment_status === "valid" ? <span className="text-emerald-600 text-xs font-semibold">✓ Tervalidasi</span> :
      canValidate ? <Button size="sm" data-testid={`btn-validate-payment-${r.id.slice(0,8)}`} className="h-8 gap-1.5 bg-emerald-600 hover:bg-emerald-700" onClick={() => validate(r.id)}><CheckCircle2 className="w-4 h-4" /> Validasi Lunas</Button> :
      <span className="text-slate-400 text-xs">menunggu finance</span>
    ) },
  ];

  const pending = orders.filter((o) => o.payment_status !== "valid").length;

  return (
    <div>
      <PageHeader title="Validasi Pembayaran" subtitle={`${pending} order menunggu validasi. Hanya order valid yang masuk shopping list.`} />
      <DataTable testId="payments-table" columns={columns} data={orders} searchKeys={["customer_name", "payment_status"]} exportName={`payments-${event?.code}`} />
    </div>
  );
}
